module.exports = "/assets/data/667093aa64347a934f20b29428c82373-SM4.data.json";